var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center mt-4 mx-auto position-absolute",staticStyle:{"z-index":"99999"}},[_c('ModalRoot',{ref:"modal"},[_c('GallerySections',{attrs:{"images":_vm.pictures,"prestations":_vm.prestations},on:{"close":_vm.closeModal}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }